import { render, staticRenderFns } from "./BirthdaySection.vue?vue&type=template&id=3d53bb59&scoped=true"
import script from "./BirthdaySection.vue?vue&type=script&lang=js"
export * from "./BirthdaySection.vue?vue&type=script&lang=js"
import style0 from "./BirthdaySection.vue?vue&type=style&index=0&id=3d53bb59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53bb59",
  null
  
)

export default component.exports